/**
 * i18n dictionaries. Keep keys stable — add translations, do not rename keys.
 * Coverage: Layout, Login, Dashboard, Clients, Findings, Reports, common toasts.
 */
export const DEFAULT_LOCALE = "es";
export const SUPPORTED_LOCALES = ["es", "en"];

export const DICTIONARIES = {
  es: {
    // Layout · Sidebar
    "nav.clients": "Clientes",
    "nav.dashboard": "Postura de seguridad",
    "nav.attack_surface": "Superficie de ataque",
    "nav.assets": "Activos",
    "nav.findings": "Hallazgos",
    "nav.vendors": "Riesgo de terceros",
    "nav.threat_intel": "Inteligencia de amenazas",
    "nav.alert_rules": "Reglas de alerta",
    "nav.scanners": "Ethical Hacking",
    "nav.reports": "Informes",
    "nav.settings": "Configuración",
    "nav.ai_analyst": "Analista IA",
    "layout.brand_subtitle": "CEIP · v0.2",
    "layout.live_monitoring": "CIBRAXIS · Monitoreo continuo · en vivo",
    "layout.logout": "Cerrar sesión",
    "lang.toggle_aria": "Cambiar idioma",
    "lang.es": "ES",
    "lang.en": "EN",
    // Cookie banner
    "banner.cookies_blocked.title": "Tu navegador está bloqueando cookies",
    "banner.cookies_blocked.body":
      "La sesión durará solo mientras la pestaña esté abierta. Si cierras o recargas, tendrás que iniciar sesión de nuevo.",
    "banner.cookies_blocked.dismiss": "Entendido",
    // Login
    "login.overline": "Iniciar sesión",
    "login.title": "Acceder a la consola",
    "login.email": "Usuario",
    "login.password": "Contraseña",
    "login.submit": "Entrar a la consola",
    "login.demo_credentials": "Credenciales de demo",
    "login.failed": "Usuario o contraseña inválidos",
    "login.brand_subline": "",
    "login.headline_1": "Ve lo que un atacante",
    "login.headline_2": "podría ver.",
    "login.headline_3": "Actúa antes que él.",
    "login.pitch":
      "La consola multi-tenant para consultores de ciberseguridad. Cartera de clientes · Puntaje de riesgo 1–100 · Ingesta de activos · Inteligencia de puertos Shodan · Alertas por correo · Copiloto IA.",
    "login.step_1": "DESCUBRIMIENTO",
    "login.step_2": "CALIFICACIÓN",
    "login.step_3": "REMEDIACIÓN",
    // Common
    "common.loading": "Cargando…",
    "common.loading_console": "Cargando consola...",
    "common.loading_portfolio": "Cargando cartera...",
    "common.view_all": "Ver todos",
    "common.of_100": "/100",
    // Rating card
    "rating.overline": "Calificación general de seguridad",
    "rating.vs_prev": "vs anterior",
    "rating.scale": "Escala de calificación",
    // Add client modal
    "add_client.overline": "Nuevo cliente",
    "add_client.title": "Onboarding de una empresa",
    "add_client.name": "Nombre de la empresa",
    "add_client.industry": "Industria",
    "add_client.country": "País",
    "add_client.criticality": "Criticidad",
    "add_client.crit_low": "baja",
    "add_client.crit_medium": "media",
    "add_client.crit_high": "alta",
    "add_client.crit_critical": "crítica",
    "add_client.domains": "Dominios raíz (separados por coma)",
    "add_client.domains_placeholder": "ejemplo.com, api.ejemplo.com",
    "add_client.ips": "IPs / CIDR (separados por coma)",
    "add_client.ips_placeholder": "203.0.113.10, 198.51.100.0/24",
    "add_client.cancel": "Cancelar",
    "add_client.submit": "Crear cliente",
    "add_client.error_create": "No se pudo crear el cliente",
    // Dashboard
    "dashboard.overline": "Consola · Vista general",
    "dashboard.title": "Postura de seguridad",
    "dashboard.subtitle":
      "Visibilidad continua de la superficie de ataque externa, calificación contextual de riesgo y monitoreo de terceros.",
    "dashboard.algo_prefix": "Algoritmo v",
    "dashboard.kpi.critical": "Críticos",
    "dashboard.kpi.high": "Altos",
    "dashboard.kpi.critical_hint": "Activos",
    "dashboard.kpi.high_hint": "Activos",
    "dashboard.kpi.kev": "Coincidencias KEV",
    "dashboard.kpi.kev_hint": "Explotados conocidos",
    "dashboard.kpi.subdomains": "Subdominios",
    "dashboard.kpi.subdomains_hint": "{count} dominios",
    "dashboard.kpi.services": "Servicios",
    "dashboard.kpi.services_hint": "Expuestos",
    "dashboard.kpi.certs": "Cert. próximos a vencer",
    "dashboard.kpi.certs_hint": "< 30 días",
    "dashboard.trend.overline": "Tendencia de calificación",
    "dashboard.trend.title": "Evolución de 12 meses",
    "dashboard.delta.overline": "Tendencia global · clientes ALTO",
    "dashboard.delta.title": "Nuevos hallazgos por día",
    "dashboard.delta.subtitle": "Suma diaria de delta_new de todos los escaneos programados de clientes categoría ALTO",
    "dashboard.delta.no_alto": "Sin clientes categoría ALTO — clasifica alguno para ver la tendencia",
    "dashboard.delta.new_total": "Nuevos (14 días)",
    "dashboard.delta.resolved_total": "Resueltos",
    "dashboard.delta.runs_total": "Ejecuciones",
    "dashboard.delta.top_clients": "Top clientes por delta",
    "dashboard.sev.overline": "Hallazgos por severidad",
    "dashboard.sev.title": "Distribución",
    "dashboard.categories.overline": "Desglose por categoría",
    "dashboard.categories.title": "13 señales que contribuyen a tu calificación",
    "dashboard.categories.findings_grade": "{count} hallazgos · Nota {letter}",
    "dashboard.drivers.overline": "Impulsores de la calificación",
    "dashboard.drivers.title": "Qué te está afectando",
    "dashboard.wins.overline": "Ganancias rápidas",
    "dashboard.top.overline": "Mayor riesgo",
    "dashboard.top.title": "Principales hallazgos explotables",
    "dashboard.top.col.finding": "Hallazgo",
    "dashboard.top.col.sev": "Sev",
    "dashboard.top.col.risk": "Riesgo",
    "dashboard.top.col.asset": "Activo",
    "dashboard.alerts.overline": "Centro de alertas",
    "dashboard.alerts.title": "Eventos recientes",
    // Clients
    "clients.overline": "Consola de consultor · Cartera",
    "clients.title": "Clientes",
    "clients.subtitle": "Cada organización que monitoreas, ordenada por su puntaje de riesgo de exposición en vivo.",
    "clients.add": "Añadir cliente",
    "clients.added_toast": "Cliente añadido",
    "clients.kpi.clients": "Clientes",
    "clients.kpi.high_risk": "Clientes de alto riesgo",
    "clients.kpi.critical_findings": "Hallazgos críticos",
    "clients.kpi.assets": "Activos monitoreados",
    "clients.search_placeholder": "Buscar por nombre de empresa...",
    "clients.sort.label": "Ordenar",
    "clients.sort.risk": "Riesgo",
    "clients.sort.name": "Nombre",
    "clients.sort.created": "Más recientes",
    "clients.empty_none": "Aún no hay clientes — añade el primero para comenzar a monitorear.",
    "clients.empty_search": 'Ningún cliente coincide con "{q}"',
    "clients.card.risk_score": "Puntaje de riesgo",
    "clients.card.critical": "{n} críticos",
    "clients.card.high": "{n} altos",
    "clients.card.kev": "{n} KEV",
    "clients.card.assets": "{n} activos",
    // Findings
    "findings.overline": "Gestión de vulnerabilidades",
    "findings.title": "Hallazgos",
    "findings.subtitle": "Problemas ordenados por riesgo contextual detectados en tu superficie de ataque externa.",
    "findings.filter.sev": "Severidad",
    "findings.filter.status": "Estado",
    "findings.filter.all": "TODOS",
    "findings.col.finding": "Hallazgo",
    "findings.col.category": "Categoría",
    "findings.col.sev": "Sev",
    "findings.col.risk": "Riesgo",
    "findings.col.cvss": "CVSS",
    "findings.col.epss": "EPSS",
    "findings.col.asset": "Activo",
    "findings.col.status": "Estado",
    "findings.empty": "Ningún hallazgo coincide con los filtros.",
    // Reports
    "reports.overline": "Reportes · Vista previa",
    "reports.title": "Informes",
    "reports.subtitle": "Vista previa del informe ejecutivo, técnico y de cartera. Exportación PDF disponible.",
    "reports.download": "PDF ejecutivo",
    "reports.download_portfolio": "PDF cartera",
    "reports.download_portfolio_hint": "Genera un PDF multi-cliente con el mix ENS del portafolio",
    "reports.portfolio_downloaded": "PDF de cartera descargado",
    "reports.download_toast": "PDF descargado",
    "reports.download_failed": "Falló la exportación PDF: {msg}",
    "reports.tab.exec": "Resumen ejecutivo",
    "reports.tab.tech": "Informe técnico",
    "reports.tab.portfolio": "Cartera (clientes)",
    "reports.exec.overline": "Resumen ejecutivo · CIBRAXIS",
    "reports.exec.title": "Postura de exposición cibernética",
    "reports.exec.generated": "Generado {date} · Algoritmo v{ver}",
    "reports.exec.overall": "Calificación general · tendencia {trend} · delta {delta}",
    "reports.exec.drivers": "Impulsores de la calificación",
    "reports.exec.actions": "Acciones recomendadas",
    "reports.exec.breakdown": "Desglose por categoría",
    "reports.exec.footer": "Fin del resumen ejecutivo · CIBRAXIS · Confidencial",
    "reports.tech.overline": "Informe técnico · CIBRAXIS",
    "reports.tech.title": "Registro de vulnerabilidades",
    "reports.tech.generated": "Generado {date} · {count} hallazgos mostrados",
    "reports.tech.overall": "General",
    "reports.tech.letter": "Letra",
    "reports.tech.trend": "Tendencia",
    "reports.tech.findings": "Hallazgos",
    "reports.tech.col.title": "Título",
    "reports.tech.footer": "Fin del informe técnico · CIBRAXIS · Confidencial",
    "reports.portfolio.overline": "Revisión de cartera · CIBRAXIS",
    "reports.portfolio.title": "Cartera de riesgo de clientes",
    "reports.portfolio.subtitle": "{count} clientes monitoreados · ordenados por riesgo",
    "reports.portfolio.footer": "Fin de la revisión de cartera · CIBRAXIS · Confidencial",
  },
  en: {
    // Layout · Sidebar
    "nav.clients": "Clients",
    "nav.dashboard": "Security posture",
    "nav.attack_surface": "Attack surface",
    "nav.assets": "Assets",
    "nav.findings": "Findings",
    "nav.vendors": "Third-party risk",
    "nav.threat_intel": "Threat intelligence",
    "nav.alert_rules": "Alert rules",
    "nav.scanners": "Ethical Hacking",
    "nav.reports": "Reports",
    "nav.settings": "Settings",
    "nav.ai_analyst": "AI Analyst",
    "layout.brand_subtitle": "CEIP · v0.2",
    "layout.live_monitoring": "CIBRAXIS · Continuous monitoring · live",
    "layout.logout": "Sign out",
    "lang.toggle_aria": "Change language",
    "lang.es": "ES",
    "lang.en": "EN",
    // Cookie banner
    "banner.cookies_blocked.title": "Your browser is blocking cookies",
    "banner.cookies_blocked.body":
      "Your session will last only while this tab stays open. Closing or refreshing will require signing in again.",
    "banner.cookies_blocked.dismiss": "Got it",
    // Login
    "login.overline": "Sign in",
    "login.title": "Access the console",
    "login.email": "Email address",
    "login.password": "Password",
    "login.submit": "Enter the console",
    "login.demo_credentials": "Demo credentials",
    "login.failed": "Invalid username or password",
    "login.brand_subline": "",
    "login.headline_1": "See what an attacker",
    "login.headline_2": "could see.",
    "login.headline_3": "Act before they do.",
    "login.pitch":
      "The multi-tenant console for cybersecurity consultants. Client portfolio · Risk score 1–100 · Asset ingest · Shodan port intelligence · Email alerts · AI Copilot.",
    "login.step_1": "DISCOVERY",
    "login.step_2": "RATING",
    "login.step_3": "REMEDIATION",
    // Common
    "common.loading": "Loading…",
    "common.loading_console": "Loading console...",
    "common.loading_portfolio": "Loading portfolio...",
    "common.view_all": "View all",
    "common.of_100": "/100",
    // Rating card
    "rating.overline": "Overall security rating",
    "rating.vs_prev": "vs previous",
    "rating.scale": "Rating scale",
    // Add client modal
    "add_client.overline": "New client",
    "add_client.title": "Onboard a company",
    "add_client.name": "Company name",
    "add_client.industry": "Industry",
    "add_client.country": "Country",
    "add_client.criticality": "Criticality",
    "add_client.crit_low": "low",
    "add_client.crit_medium": "medium",
    "add_client.crit_high": "high",
    "add_client.crit_critical": "critical",
    "add_client.domains": "Root domains (comma-separated)",
    "add_client.domains_placeholder": "example.com, api.example.com",
    "add_client.ips": "IPs / CIDR (comma-separated)",
    "add_client.ips_placeholder": "203.0.113.10, 198.51.100.0/24",
    "add_client.cancel": "Cancel",
    "add_client.submit": "Create client",
    "add_client.error_create": "Could not create the client",
    // Dashboard
    "dashboard.overline": "Console · Overview",
    "dashboard.title": "Security posture",
    "dashboard.subtitle":
      "Continuous visibility of the external attack surface, contextual risk rating and third-party monitoring.",
    "dashboard.algo_prefix": "Algorithm v",
    "dashboard.kpi.critical": "Critical",
    "dashboard.kpi.high": "High",
    "dashboard.kpi.critical_hint": "Active",
    "dashboard.kpi.high_hint": "Active",
    "dashboard.kpi.kev": "KEV matches",
    "dashboard.kpi.kev_hint": "Known exploited",
    "dashboard.kpi.subdomains": "Subdomains",
    "dashboard.kpi.subdomains_hint": "{count} domains",
    "dashboard.kpi.services": "Services",
    "dashboard.kpi.services_hint": "Exposed",
    "dashboard.kpi.certs": "Certs expiring soon",
    "dashboard.kpi.certs_hint": "< 30 days",
    "dashboard.trend.overline": "Rating trend",
    "dashboard.trend.title": "12-month evolution",
    "dashboard.delta.overline": "Global trend · ALTO clients",
    "dashboard.delta.title": "New findings per day",
    "dashboard.delta.subtitle": "Daily sum of delta_new across all scheduled scans for ENS ALTO clients",
    "dashboard.delta.no_alto": "No ALTO clients — classify one to unlock this trend",
    "dashboard.delta.new_total": "New (14 days)",
    "dashboard.delta.resolved_total": "Resolved",
    "dashboard.delta.runs_total": "Runs",
    "dashboard.delta.top_clients": "Top clients by delta",
    "dashboard.sev.overline": "Findings by severity",
    "dashboard.sev.title": "Distribution",
    "dashboard.categories.overline": "Category breakdown",
    "dashboard.categories.title": "13 signals contributing to your rating",
    "dashboard.categories.findings_grade": "{count} findings · Grade {letter}",
    "dashboard.drivers.overline": "Rating drivers",
    "dashboard.drivers.title": "What's hurting you",
    "dashboard.wins.overline": "Quick wins",
    "dashboard.top.overline": "Highest risk",
    "dashboard.top.title": "Top exploitable findings",
    "dashboard.top.col.finding": "Finding",
    "dashboard.top.col.sev": "Sev",
    "dashboard.top.col.risk": "Risk",
    "dashboard.top.col.asset": "Asset",
    "dashboard.alerts.overline": "Alert center",
    "dashboard.alerts.title": "Recent events",
    // Clients
    "clients.overline": "Consultant console · Portfolio",
    "clients.title": "Clients",
    "clients.subtitle": "Every organization you monitor, sorted by their live exposure risk score.",
    "clients.add": "Add client",
    "clients.added_toast": "Client added",
    "clients.kpi.clients": "Clients",
    "clients.kpi.high_risk": "High-risk clients",
    "clients.kpi.critical_findings": "Critical findings",
    "clients.kpi.assets": "Monitored assets",
    "clients.search_placeholder": "Search by company name...",
    "clients.sort.label": "Sort",
    "clients.sort.risk": "Risk",
    "clients.sort.name": "Name",
    "clients.sort.created": "Newest",
    "clients.empty_none": "No clients yet — add the first one to start monitoring.",
    "clients.empty_search": 'No client matches "{q}"',
    "clients.card.risk_score": "Risk score",
    "clients.card.critical": "{n} critical",
    "clients.card.high": "{n} high",
    "clients.card.kev": "{n} KEV",
    "clients.card.assets": "{n} assets",
    // Findings
    "findings.overline": "Vulnerability management",
    "findings.title": "Findings",
    "findings.subtitle": "Issues sorted by contextual risk, detected on your external attack surface.",
    "findings.filter.sev": "Severity",
    "findings.filter.status": "Status",
    "findings.filter.all": "ALL",
    "findings.col.finding": "Finding",
    "findings.col.category": "Category",
    "findings.col.sev": "Sev",
    "findings.col.risk": "Risk",
    "findings.col.cvss": "CVSS",
    "findings.col.epss": "EPSS",
    "findings.col.asset": "Asset",
    "findings.col.status": "Status",
    "findings.empty": "No finding matches the filters.",
    // Reports
    "reports.overline": "Reports · Preview",
    "reports.title": "Reports",
    "reports.subtitle": "On-screen preview of executive, technical and portfolio reports. PDF export available.",
    "reports.download": "Executive PDF",
    "reports.download_portfolio": "Portfolio PDF",
    "reports.download_portfolio_hint": "Multi-client PDF showing the portfolio ENS mix",
    "reports.portfolio_downloaded": "Portfolio PDF downloaded",
    "reports.download_toast": "PDF downloaded",
    "reports.download_failed": "PDF export failed: {msg}",
    "reports.tab.exec": "Executive summary",
    "reports.tab.tech": "Technical report",
    "reports.tab.portfolio": "Portfolio (clients)",
    "reports.exec.overline": "Executive summary · CIBRAXIS",
    "reports.exec.title": "Cyber exposure posture",
    "reports.exec.generated": "Generated {date} · Algorithm v{ver}",
    "reports.exec.overall": "Overall rating · trend {trend} · delta {delta}",
    "reports.exec.drivers": "Rating drivers",
    "reports.exec.actions": "Recommended actions",
    "reports.exec.breakdown": "Category breakdown",
    "reports.exec.footer": "End of executive summary · CIBRAXIS · Confidential",
    "reports.tech.overline": "Technical report · CIBRAXIS",
    "reports.tech.title": "Vulnerability register",
    "reports.tech.generated": "Generated {date} · {count} findings shown",
    "reports.tech.overall": "Overall",
    "reports.tech.letter": "Letter",
    "reports.tech.trend": "Trend",
    "reports.tech.findings": "Findings",
    "reports.tech.col.title": "Title",
    "reports.tech.footer": "End of technical report · CIBRAXIS · Confidential",
    "reports.portfolio.overline": "Portfolio review · CIBRAXIS",
    "reports.portfolio.title": "Client risk portfolio",
    "reports.portfolio.subtitle": "{count} clients monitored · sorted by risk",
    "reports.portfolio.footer": "End of portfolio review · CIBRAXIS · Confidential",
  },
};
